<template>
    <div>
        <CRow>
            <CCol col="12">
                <CCard>
                    <CCardBody class="p-2">
                        <CTabs>
                            <CTab title="생육측정 정보" active>
                                <div class="p-2">
                                    <div class="row">
                                        <CCol col="12">
                                            <GrowthInformation />
                                        </CCol>
                                    </div>
                                </div>
                            </CTab>
                            <CTab title="생육측정 입력">
                                <div class="p-2">
                                    <div class="row">
                                        <CCol>
                                            <GrowthInformationInput />
                                        </CCol>
                                    </div>
                                </div>
                            </CTab>
                            <CTab title="사진 업로드">
                                <div class="p-2">
                                    <div class="row">
                                        <CCol col="12">
                                            <GrowthDiseaseImageInput />
                                        </CCol>
                                    </div>
                                </div>
                            </CTab>
                            <CTab title="파일 현황">
                                <div class="p-2">
                                    <div class="row">
                                        <CCol col="12">
                                            <GrowthFileInformation />
                                        </CCol>
                                    </div>
                                </div>
                            </CTab>
                        </CTabs>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import MixinsInFacility from "@/mixins/in-facility";
    import GrowthInformation from "@/components/analysis/GrowthInformationComponent";
    import GrowthInformationInput from "@/components/analysis/GrowthInformationInputComponent";
    import GrowthDiseaseImageInput from "@/components/analysis/GrowthDiseaseImageInputComponent";
    import GrowthFileInformation from "@/components/analysis/GrowthFileInformationComponent";
    import core from "@/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import * as am4core from "@amcharts/amcharts4/core";

    export default {
        name: "GrowthMeasure",
        components: {
            GrowthInformation,
            GrowthInformationInput,
            GrowthDiseaseImageInput,
            GrowthFileInformation
        },
        mixins: [MixinsInFacility()],
        data() {
            return {
                chart: null,
            };
        },
        mounted() {
            //tab list responsive 
            document.getElementsByClassName("nav-item").forEach(function (v, i) {
                v.classList.add('col-sm-12');
                v.classList.add('col-md-6');
                v.classList.add('col-lg-3');
            })
        },
        watch: {
            inFacilityId(val) {
                if (val != null) {
                }
            },
        }
    };
</script>